<template>
  <div id="app">
    <AppHeader v-if="!isTemporaryHomePage" />
    <main class="main-content" :class="{ 'no-header-footer': isTemporaryHomePage }">
      <router-view />
    </main>
    <AppFooter v-if="!isTemporaryHomePage" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from './components/layout/AppHeader.vue';
import AppFooter from './components/layout/AppFooter.vue';
import { appConfig } from './config/appConfig';

const route = useRoute();

// 判断当前是否为临时首页
const isTemporaryHomePage = computed(() => {
  return appConfig.showTempHomePage && route.path === '/';
});
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  line-height: 1.5;
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 4rem; /* 添加顶部内边距，等于header的高度 */
  min-height: calc(100vh - 16rem); /* 减去header和footer的高度 */
}

.main-content.no-header-footer {
  padding-top: 0;
  min-height: 100vh;
}

a {
  text-decoration: none;
}

img {
  max-width: 100%;
}

button {
  cursor: pointer;
}

/* 通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
}
</style>
